import React from 'react';

import { CircularProgress } from '@mui/material';

import { SIZE_SM } from '../../../../constants/buttons';
import { CONTROLLER_ON, WHITE } from '../../../../constants/colors';
import { IBdsTextButton } from '../../../../interfaces/buttons';
import './BdsTextButton.scss';

const customStyles = {
  customLoadingWhite: {
    color: WHITE
  },
  customLoadingBlack: {
    color: CONTROLLER_ON
  }
};

const BdsTextButton = ({
  action,
  disabled,
  children,
  iconLeft,
  iconRight,
  loading = false
}: React.PropsWithChildren<IBdsTextButton>) => {
  if (loading) {
    return <CircularProgress sx={{ ...customStyles.customLoadingBlack }} size={SIZE_SM} />;
  }

  return (
    <button disabled={disabled} className="bds-text-button" onClick={action}>
      {iconLeft && <iconLeft.component className="bds-button-icon" />}
      <div className="bds-text-button-text">{children}</div>
      {iconRight && <iconRight.component className="bds-button-icon" />}
    </button>
  );
};

export default BdsTextButton;
